import React, { useEffect } from "react";
import { DashboardsEmbedWrapper } from "./dashboardEmbed";
import { cookieAttributes } from "util/resumeCookieSettings";

function QueryVizualizationReportPage(props) {
  useEffect(() => {
    async function setResumeCookie() {
      const cookieValue = encodeURIComponent(`Query Visualization - /queryvisualization/${props?.match?.params?.jobId}`);
      const resumeCookie = Object.assign(cookieAttributes(), { name: 'platform_resume' }, { value: cookieValue });
      await cookieStore.set(resumeCookie);
    }
    setResumeCookie();
  }, [props?.match?.params?.jobId]);

  return (
    <div className="card">
      <div className="card-header text-light font-weight-bold container-fluid">
        <div className="row">
          <div className="col-12">Query Visualization {props?.match?.params?.visualizationId}</div>
        </div>
      </div>
      <div>
        {props?.match?.params?.jobId && <DashboardsEmbedWrapper dashboardId={props?.match?.params?.jobId} />}
      </div>
    </div>
  );
}

export default QueryVizualizationReportPage;